import { render, staticRenderFns } from "./CropsTotalsTable.vue?vue&type=template&id=d65f856a&"
import script from "./CropsTotalsTable.vue?vue&type=script&lang=js&"
export * from "./CropsTotalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports